import React, { useState, useEffect } from "react";
import Header from "./components/Header";
import MainContent from "./components/MainContent";
import SiteFooter from "./components/SiteFooter";
import { auth } from "../src/Firebase/FirebaseConfig";
import { BrowserRouter as Router } from "react-router-dom";
import "./App.css";

const App = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setLoading(false);
    });

    return () => unsubscribe(); // Clean up the subscription
  }, []);

  if (loading) {
    return (
      <div className="app-loading" role="status">
        <span className="app-loading__mark">CRAFT</span>
        <span>Opening your tap list…</span>
      </div>
    );
  }

  return (
    <Router>
      <div className="app-shell">
        <Header />
        <MainContent />
        <SiteFooter />
      </div>
    </Router>
  );
};

export default App;
